import apiArk from "./Ark"

export default {
  getALPs() {
    return apiArk.get("energy_usage_load_factors/alps")
  },
}
